import React from 'react';
import styled from 'styled-components';
import { IMaskMixin } from 'react-imask';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 20px;
  font-family:"Avenir Next LT W01 Demi";
`;

export const SmallTitle = styled.div`
  font-family: 'Avenir Next LT W01 Demi';
  font-size: 14px;
  font-weight: normal;
  align-items: center;
  text-align: left;
  margin-bottom: 5px;
`;

export const SupportItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`;

export const Checkbox = styled.input`
  margin-right: 5px;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const SelectorImage = styled.img`
  margin-bottom: 4px;
`;

export const Label = styled.label`
  font-family: "AvenirNextLTW01-Regular";
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
`;

export const UnespecificSupportContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AmountBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const AmountBox = styled.div`
  height: 48px;
  min-width: 100px;
  font: bold 24px/48px "AvenirNextLTW01-Regular";
  color: ${(props) => (props.checked ? '#FFF;' : '#17BFDD;')}
  border: 1px solid #17BFDD;
  border-radius: 5px;
  margin: 0 12px 12px 0;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  ${(props) => (props.checked ? 'background: #17BFDD;' : '')}
`;

export const AmountInput = styled.input`
  height: 48px;
  width: 100%;
  max-width: 255px;
  font: bold 24px/48px "AvenirNextLTW01-Regular";
  color: #17BFDD;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  padding: 0 15px;
  background: transparent;
`;

export const AmountInputMasked = IMaskMixin(({ inputRef, ...props }) => (
  <AmountInput
    {...props}
    ref={inputRef}
  />
));

export const SpecificSupportContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GoalContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
`;

export const GoalImageContainer = styled.div`
  width: 68px;
  height: 68px;
  padding: 3px;
  background: #fff;
  border: 2px solid #09798D;
  border-radius: 50%;
  margin-right: 15px;
  background-size: cover;
  flex-shrink: 0;
`;

export const GoalImage = styled.img`
  border-color: transparent;
  background-color: #09798D;
  border: 1px solid #D2D2D2;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const GoalInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "AvenirNextLTW01-Regular";
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
`;

export const GoalInfoName = styled.label`
  font-weight: 500;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 25px;
`;

export const GoalInfoSavedAmount = styled.label`
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const GoalInfoAmountContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-left: auto;
  flex-shrink: 0;
  max-width: 95px;
  height: 40px;
`;

export const GoalInfoAmountInput = styled.input`
  width: 100%;
  height: 100%;
  outline: none;
  padding: 0 10px;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  transition: border-color .3s ease;
`;

export const GoalInfoAmountInputMasked = IMaskMixin(({ inputRef, ...props }) => (
  <GoalInfoAmountInput
    {...props}
    ref={inputRef}
  />
));

export const GoalTotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 20px;
  border-top: 1px solid #D2D2D2;
  font-family: "AvenirNextLTW01-Regular"
`;

export const GoalTotalLabel = styled.label`
  margin-top: 10px;
  margin-bottom: 0px;
  font-weight: 500;
  line-height: 1;
`;
